/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


let config = {  
    
    
    title : {
        key :'title',
        value : 'RSIA Restu Ibu'
    },
        
    iframe : {
        key   : 'iframe-1',
        value : 'https://www.youtube.com/embed/_7pybooWrxE?Version=3&rel=0&autoplay=1&mute=1&loop=1&playlist=_7pybooWrxE',
    },
    
    
}

export default config;

